export default __webpack_public_path__ + "components/buttons/static/mountain-forecast__logo-c42581ad9b6682b1c6718e48d8d56f6e.svg";